import { Maker } from './buildMachine';
import { Ctx, Snap } from './core';

export const queuesFallback: Maker<Ctx, Snap, null> = ({ makeEffect }) => [
  makeEffect(
    'iframeMsgs',
    (_, { ctx, cond }) => cond(ctx.iframeMsgs[0], 'unhandled'),
    (_msg, { ctx }) => ctx.iframeMsgs.shift(),
  ),

  makeEffect(
    'axios',
    (_, { ctx, cond }) => cond(ctx.axios.active[0]?.res, 'unhandled response'),
    (_msg, { ctx }) => ctx.axios.active.shift(),
  ),
];
